import { FeatureFlags, FEATURE_FLAG_RECORD_MAP } from './feature-flags'
import { ServiceUrls, SERVICE_URLS_RECORD_MAP } from './service-urls'

export const BaseEnvironment = {
  RedirectUrlKey: 'REDIRECT_URL_KEY',
} as const

export type BaseEnvironment = typeof BaseEnvironment

export const EnvironmentFromFile = {
  ...FEATURE_FLAG_RECORD_MAP,
  ...SERVICE_URLS_RECORD_MAP,

  Adobe: 'ADOBE_DTM',
  AuthKey: 'AUTH0_AUTH_KEY',
  SearchChannelId: 'SEARCH_CHANNEL_ID',
  SegmentKey: 'SEGMENT_KEY',
  Auth0DatabaseName: 'AUTH0_DATABASE_NAME',
  Auth0ClientId: 'AUTH0_CLIENT_ID',
  promoBannerName: 'PROMO_BANNER_NAME',
  CinchChargeCardRequestAPIKey: 'CINCH_CHARGE_CARD_REQUEST_API_KEY',
  AdminFeeValue: 'ADMIN_FEE_VALUE',
  LogisticsFulfilmentServiceApiKey: 'LOGISTICS_FULFILMENT_SERVICE_API_KEY',
  StripePublishableKey: 'STRIPE_PUBLISHABLE_KEY',
  CustomerDataAPIKey: 'CUSTOMER_DATA_API_KEY',
  NavbarValuationExperimentId: 'NAVBAR_VALUATION_EXPERIMENT_ID',
  StoreAvailabilityKey: 'STORE_AVAILABILITY_KEY',
  GoogleMapsApiKey: 'GOOGLE_GEOCODING_API_KEY',
  SitesApiKey: 'SITES_API_KEY',
  FinanceSDDPdf: 'FINANCE_SDD_PDF',
  FinanceCommissionPdf: 'FINANCE_COMMISSION_PDF',
  proposalSubmissionAPIKey: 'PROPOSAL_SUBMISSION_API_KEY',
  IdealPostcodesApiKey: 'IDEAL_POSTCODES_API_KEY',
  UnsubscribeMinimunDuration: 'UNSUBSCRIBE_MINIMUM_DURATION',
  RepresentativeAprUsedCar: 'REPRESENTATIVE_APR_USED_CAR',
  FeatureFlagApiKey: 'FEATURE_FLAG_API_KEY',

  // ACQUISITION AND CONTENT & SEARCH
  AiSearchExperimentId: 'AI_SEARCH_EXPERIMENT_ID',
} as const

export type EnvironmentFromFile = typeof EnvironmentFromFile

export const EnvironmentFromProcess = {
  DataDogAPIKey: 'DATADOG_API_KEY',
  DataDogClientId: 'DATADOG_CLIENT_ID',
  DataDogRumApplicationId: 'DATADOG_RUM_APPLICATION_ID',
  DataDogRumClientToken: 'DATADOG_RUM_CLIENT_TOKEN',
  DataDogRumGlobalSampleRate: 'DATADOG_RUM_GLOBAL_SAMPLE_RATE',
  DataDogRumGlobalReplaySampleRate: 'DATADOG_RUM_GLOBAL_REPLAY_SAMPLE_RATE',
  DataDogServiceName: 'DATADOG_SERVICE_NAME',
  BuildId: 'BUILD_ID',
} as const

export type EnvironmentFromProcess = typeof EnvironmentFromProcess

export type IBaseEnvironment = Record<
  BaseEnvironment[keyof BaseEnvironment],
  string | undefined
> & {
  REDIRECT_URL_KEY: string
}

export type IEnvironmentFromFile = Record<
  EnvironmentFromFile[keyof EnvironmentFromFile],
  string | undefined
> &
  Record<FeatureFlags[keyof FeatureFlags], 'true' | 'false'> &
  Record<ServiceUrls[keyof ServiceUrls], string>

export type IEnvironmentFromProcess = Record<
  EnvironmentFromProcess[keyof EnvironmentFromProcess],
  string | undefined
> & {
  BUILD_ID: string | undefined
  DATADOG_API_KEY: string | undefined
  DATADOG_CLIENT_ID: string | undefined
  DATADOG_RUM_APPLICATION_ID: string | undefined
  DATADOG_RUM_CLIENT_TOKEN: string | undefined
  DATADOG_RUM_GLOBAL_SAMPLE_RATE: string | undefined
  DATADOG_SERVICE_NAME: string | undefined
  DATADOG_RUM_GLOBAL_REPLAY_SAMPLE_RATE: string | undefined
}

export interface IEnvironment
  extends IBaseEnvironment,
    IEnvironmentFromFile,
    IEnvironmentFromProcess {}

export const Env = {
  ...BaseEnvironment,
  ...EnvironmentFromFile,
  ...EnvironmentFromProcess,
}

export type Env = BaseEnvironment & EnvironmentFromFile & EnvironmentFromProcess

export type keys = keyof IEnvironment
